<template>
    <div class="contain">
        <section class="section section_style" id="home">
            <h2>Confirmed Companies</h2>

            <button @click="exportExcel" class="btn btn-default float-right">Export as Excel</button>
            <div class="clear-both"></div>

            <table v-if="loaded && companies" id="myTable" class="display">
                <thead>
                    <tr v-if="companies">
                        <th>Company</th>
                        <th>Country</th>
                        <th>Sector</th>
                        <th>Bloomberg</th>
                        <th>Reuter</th>
                        <th>Presentations</th>
                        <th>Research Report</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(company, index) in companies" v-bind:key="index">
                        <td v-if="company.website">
                            <a class="toolTip-wrapper" style="position: relative" :href="company.website" target="_blank">
                                {{ company.name }}
                                <span class="toolTip">Website: {{ company.website }}</span>
                            </a>
                        </td>
                        <td v-if="!company.website">
                            <a href="#"> {{ company.name }} </a>
                        </td>
                        <td>{{ company.country.name }}</td>
                        <td>{{ company.sector.name }}</td>
                        <td>{{ company.bloomberg }}</td>
                        <td>{{ company.reuter }}</td>

                        <td class="presntation-font">
                            <div>
                                <div class="_put-cursor" :v-if="company.uploads.length > 0"
                                    v-for="(upload, index) in company.uploads" :key="index">
                                    <span v-on:click="downloadFile(
                                            company.id,
                                            upload.id,
                                            'presentation'
                                        )
                                        " v-if="upload.presentation">
                                        Download Presentation
                                    </span>
                                </div>
                                <span style="font-weight: normal" v-if="companyHasNoPresentation(
                                        company.uploads
                                    ) &&
                                    noPresentationCompanies.includes(
                                        company.id
                                    )
                                    ">
                                    No Presentation Provided
                                </span>
                            </div>
                        </td>

                        <td class="presntation-font">
                            <div>
                                <div class="_put-cursor" :v-if="company.uploads.length > 0"
                                    v-for="(upload, index) in company.uploads" :key="index">
                                    <span v-if="upload.profile" v-on:click="downloadFile(
                                            company.id,
                                            upload.id,
                                            'profile'
                                        )
                                        ">
                                        Download Report
                                    </span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p v-if="loaded && companies.length <= 0">
                The list of attending companies will be made available soon.
            </p>
        </section>
    </div>
</template>

<script>
    import $ from "jquery";
    import Api from "@/Api";
    import JSZip from "jszip";
    import { saveAs } from 'file-saver';
    import * as XLSX from 'xlsx/xlsx.mjs';

    window.JSZip = JSZip;

    import "datatables.net";
    import "datatables.net-se";
    import "datatables.net-buttons-se";
    import "datatables.net-buttons/js/buttons.html5";
    import "datatables.net-buttons/js/dataTables.buttons";
    import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
    import "datatables.net-dt/css/jquery.dataTables.css";

    export default {
        name: "CompaniesList",
        data() {
            return {
                loaded: false,
                companies: [],
                noPresentationCompanies: [
                    "Qalaa Holdings",
                    "Housing and Development Bank",
                    "Bindawood",
                    "ZAIN KSA",
                    "Aramex",
                    "TMG Holding",
                    "Aldar Properties",
                    "Mabanee Company",
                    "Saudi Company for Hardware | SACO",
                    "Kuwait International Bank",
                    "Tawuniya",
                    "Bindawood",
                    "Credit Agricole Egypt",
                    "Saudi Ceramics",
                    "Zain KSA",
                ],
            };
        },
        methods: {
            getPageData() {
                Api()
                    .get("general/registerd-companies")
                    .then((res) => {
                        this.loaded = true;
                        this.companies = res.data.companies;
                        this.noPresentationCompanies =
                            res.data.no_presentations_companies || [];
                    })
                    .catch((error) => {
                        this.loaded = true;
                        console.log("error", error);
                    });
            },
            automaticDownloadAfterLogin() {
                let logged = this.$store.getters.isLoggedIn;
                let downloadUri = localStorage.getItem("beforeLoginChoice");
                if (logged && downloadUri) {
                    let client = JSON.parse(localStorage.getItem("client"));
                    if (downloadUri.toString() === "all") {
                        $("#myTable_wrapper .dt-buttons .buttons-excel").click();
                    } else {
                        if (client.client.client_type.type === 1) {
                            window.location =
                                process.env.VUE_APP_API_URL + downloadUri;
                        }
                    }
                }
                localStorage.removeItem("beforeLoginChoice");
            },
            downloadCompaniesList() {
                let logged = this.$store.getters.isLoggedIn;
                if (!logged) {
                    localStorage.setItem("redirect", "/companies");
                    localStorage.setItem("beforeLoginChoice", "all");
                    this.$router.push({
                        name: "login",
                    });
                } else {
                    $("#myTable_wrapper .dt-buttons .buttons-excel").click();
                }
            },
            downloadFile: function (companyId, recordId, type) {
                let conferenceId = process.env.VUE_APP_CONFERENCE_ID;
                let logged = this.$store.getters.isLoggedIn;
                if (!logged) {
                    let downloadUrl = `/files/general/download-file?company_id=${companyId}&file_type=${type}&conference_id=${conferenceId}&record_id=${recordId}`;
                    localStorage.setItem("redirect", "/companies");
                    localStorage.setItem("beforeLoginChoice", downloadUrl);
                    this.$router.push({
                        name: "login",
                    });
                } else {
                    let client = JSON.parse(localStorage.getItem("client"));
                    if (client.client.client_type.type === 1) {
                        window.location =
                            process.env.VUE_APP_API_URL +
                            `/files/general/download-file?company_id=${companyId}&file_type=${type}&conference_id=${conferenceId}&record_id=${recordId}`;
                    } else {
                        return alert("Sorry you don't have permission");
                    }
                }
            },
            companyHasNoPresentation(companyUploads) {
                const uploads = companyUploads.filter(
                    (upload) => upload.presentation !== null
                );
                return !uploads.length;
            },
            exportExcel() {
                // Create a new workbook
                const workbook = XLSX.utils.book_new();

                // Convert the company data into a worksheet
                const worksheet = XLSX.utils.json_to_sheet(this.companiesToExport);

                // Define minimum width for all columns
                const columnWidths = Object.keys(this.companiesToExport[0]).map(() => ({ wch: 30 }));

                // Set the column widths in the worksheet
                worksheet['!cols'] = columnWidths;

                // Add the worksheet to the workbook
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                // Generate the Excel file binary
                const excelBinary = XLSX.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array',
                });

                // Create a Blob object from the binary data
                const blob = new Blob([excelBinary], { type: 'application/octet-stream' });

                // Save the file using FileSaver.js
                saveAs(blob, 'companies.xlsx');
            },
        },
        computed: {
            companiesToExport() {
                return this.companies.map((company) => ({
                    'Company': company.name,
                    'Country': company.country.name,
                    'Sector': company.sector.name,
                    'Bloomberg': company.bloomberg,
                    'Reuter': company.reuter,
                }));
            },
        },
        beforeMount() {
            let client = JSON.parse(localStorage.getItem("client"));
            if (!client || !(client.client.client_type.type === 1)) {
                window.location = "/";
            }
        },
        mounted() {
            this.getPageData();
            this.automaticDownloadAfterLogin();
        },
        updated() {
            $("#myTable").DataTable({
                dom: "Bfrtip",
                pageLength: 50,
                buttons: [
                    {
                        extend: "excelHtml5",
                        exportOptions: {
                            columns: [0, 1, 2],
                        },
                    },
                ],
            });
            $("#myTable_wrapper .dt-buttons .buttons-excel").hide();
        },
    };
</script>

<style>
    .section_style {
        padding: 30px 64px;
    }

    .presntation-font {
        color: #004631;
        font-weight: bold;
    }

    ._put-cursor {
        cursor: pointer;
    }

    /* DATA TABLE STYLES */
    .dataTables_wrapper .dataTables_paginate .paginate_button.current,
    .dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
        background: none;
    }

    .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
        background: none;
        color: #a2ad1c !important;
        border: 1px solid #a2ad1c;
    }

    .dataTables_wrapper .dataTables_filter {
        color: white !important;
        background-color: #154733 !important;
    }

    .dataTables_wrapper .dataTables_filter input{
        color: white !important;
        /* background-color: #154733 !important; */
    }

    .toolTip {
        position: absolute;
        bottom: 20px;
        left: 0;
        display: none;
        background-color: yellow;
        width: 300px;
        background-color: black;
        color: white;
        font-size: 0.8rem;
        text-align: center;
        border-radius: 4px;
    }
    .toolTip-wrapper:hover .toolTip {
        display: block;
    }

    .form {
        background-color: white;
    }
    .form:hover {
        border: none;
    }

    .float-right {
        float: right;
    }
    .clear-both {
        clear: both;
    }
</style>
